<template>
	<div class="docs-list">
		<div class="docs-input btn btn--border">
			<span>Прикрепить документы</span>
			<input @change="setFiles" multiple type="file" accept="application/pdf, .xlsx, .xls">
		</div>
		<div v-for="(doc,index) in docs" :key="index" class="docs-list__item" :class="{'docs-list__item--dark' : dark}" target="_blank" :title="doc.name">
			<span class="docs-list__item-name">{{doc.name}}</span>
			<span class="docs-list__item-delete" @click.stop="removeFIle(index)"></span>
		</div>
	</div>
</template>
<script>
import {useToast} from "vue-toastification";

export default {
	name: "UploadDocs",
	emits:['update:modelValue'],

	data() {
		return {
			docs: [],
			toast: useToast(),
		}
	},
	props: {
		dark: {
			type: Boolean,
			default: false
		},
		modelValue: {
			type: Array,
			default: () => []
		},
		docsList: {
			type: Array,
			default: () => []
		}
	},

	mounted() {
		if(this.docsList.length) {
			this.docsList.forEach(item => this.docs.push(item))
		}
	},

	methods: {
		setFiles(e) {
			const [file] = e.target.files
			const fileType = file.name.match(/\.([^.]+)$|$/)[0]
			const fileSize = 15
			const fileAllowedType = '.pdf .xlsx .xls'

			if((file.size / 1024 / 1024) < fileSize) {
				if (fileAllowedType.includes(fileType)) {
					if(this.docs.length < 5) {
						this.docs = this.docs.concat(Array.from(e.target.files))
						this.$emit('update:modelValue', this.docs)
					} else {
						this.toast.error('Максимальное количество файлов 5');
					}
				} else {
					this.toast.error('Файл должен быть в формате pdf, xls, xlsx');
				}
			} else {
				this.toast.error('Размер файла не может превышать 15 Мб')
			}
			if(this.docs.length > 5) {
				this.toast.error('Максимальное количество файлов 5');
				this.docs = []
			}
		},
		removeFIle(index) {
			this.docs = this.docs.filter((item,ind) => ind !== index)
			this.$emit('update:modelValue', this.docs)
		}
	},
	watch: {
		'docsList'() {
			this.docsList.forEach(item => this.docs.push(item))
		}
	},
}
</script>
